import { useMutation } from '@tanstack/react-query'

import { axios } from '@apps-common/lib'
import { toastError, toastSuccess } from '@apps-common/lib/toast'
import { IActivationServiceRequestModel } from '@apps-common/types/portal/service-request'

export const cancelUnitActivationById = async (id: number | null): Promise<IActivationServiceRequestModel> =>
  axios.get(`/UnitActivation/cancelunitactivationrequestbyid?requestId=${id}`).then((res) => res.data?.data)

type Props = {
  id: number | null
}

export const useCancelUnitActivation = (notify?: boolean, onSuccess?: (data: IActivationServiceRequestModel) => void) =>
  useMutation({
    mutationKey: ['cancelUnitActivationById'],
    mutationFn: ({ id }: Props) => cancelUnitActivationById(id),
    onSuccess: (data) => {
      if (onSuccess) {
        onSuccess(data)
      }
      if (notify) {
        toastSuccess('Cancelled device activation.')
      }
    },
    onError: () => {
      if (notify) {
        toastError('Failed to cancel device activation, please try again.')
      }
    },
    throwOnError: false
  })
